<template>
    <v-dialog v-model="dialog" persistent width="400">
      <v-card>
        <v-card-text class="pt-2">
          <h2
          class="font-weight-regular text-xs-center"
          :class="'blue--text text--lighten-1'"
          style="line-height: initial"
          >Tem certeza que deseja cancelar o envio desse estímulo para hoje?</h2>
        </v-card-text>
        <v-card-actions class="px-0 pb-0">
          <v-btn
            dark
            block
            large
            depressed
            class="ma-0 qj-br-0"
            color="grey lighten-1"
            @click="$emit('update:dialog', false)"
          >
            Não
          </v-btn>
          <v-btn
            dark
            block
            large
            depressed
            class="ma-0 qj-br-0"
            :color="'blue lighten-1'"
            @click="confirmed"
          >
            Sim
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  
  export default {
    props: ["dialog","stimulusId","preparedAt"],
    methods: {
      confirmed() {
        this.$emit("update:dialog", false);
        this.$emit("confirmed");
      },
    },
  };
  </script>
  
  <style>
  .qj-icon-archive {
    width: 70px;
    border-radius: 50%;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .qj-br-0 {
    border-radius: 0 !important;
  }
  </style>
  